import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import { Audio } from '../../../components/molecues';
import { RecFinish } from '../../organisms';
import { RecorderService } from '../../../components/atoms';
import { ModalDialog } from '../../../../common/components/molecues';

import { MAX_RECORD_HISTORY, SHADOWING_SEND_TWICE } from '../../../common/constants.js';
import { DialogMessage } from '../../../common/DialogMessage.jsx';
import { getSplitedDivs } from '../../../../common/helper/commonHelper.js'

import renketsu from '../../../components/atoms/data/renketsu-icon.svg';
import douka from '../../../components/atoms/data/douka-icon.svg';
import datsuraku from '../../../components/atoms/data/datsuraku-icon.svg';
import ragyoka from '../../../components/atoms/data/ragyoka-icon.svg';
import jakkei from '../../../components/atoms/data/jakkei-icon.svg';

/*
props:
 onClickNext: callback function
*/

class Training4 extends Component {
    constructor(props) {
        super(props);

        this.maxPhase = 3;
        this.refAudio = React.createRef();
        this.refPlayer = React.createRef();
        this.Recorder = new RecorderService();
        this.Recorder.em.addEventListener('recording', (evt) => this.onNewRecording(evt))
        this.state = {
            sendCount: this.props.sendCount,
            phase: 0,
            prepare: 0,
            deleteReady: -1,
            sendReady: -1,
            currentRecord: "",
            currentRecordStartTime: 0,
            records: this.props.records,
            playingIndex : -1, // 録音再生中index(再生していない場合、-1)
            displayDeleteCnf: false,
            displaySendCnf: false,
            displaySentCnf: false,
            displaySaveCnf: false,
            displayMicError: false,
            displayUpgrade: false,
            displayCountOver: false,
            notRecording: false,
            recording: false,

            loadedAudio: 0,
            loading: true,
            loadingFullText: true,

            voiceChangeDisplay: false,
            voiceChangeDisable: true,
            voiceChangeMark: 1,

        }
        this.audioCallback = ()=>{}; // RecFinish画面へのcallbackを格納
        this.isTap = React.createRef(); // 2度押し制御
        this.isTap.current = false;
    }
    loadStart = () => {
        for (let key in this.state.records) {
            if (this.state.records[key] && this.state.records[key].audio) {
                this.props.dispatch({
                    type: "DownloadAudio_Saga",
                    subjectID: this.props.subject.id,
                    id: key,
                    name: this.state.records[key].audio,
                    mode: 1,
                    onSuccess: this.onSuccessAudio,
                    onFailure: this.onFailureAudio,
                });
            }
        }
        if (!this.state.records || this.state.records.length === 0) {
            this.setState({ loading: false });
        }
        if (!this.props.subject.pictureEn){this.setState({ voiceChangeDisable: false})}
    }
    loadedFullText = (audio) => {
        this.setState({ loadingFullText: false });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.isCurrent && !this.props.isCurrent) {
            // 録音再生Stop
            this.audioStop();

            if (this.state.phase === 1) {
                this.phaseNext();
                this.stopRecording();
                this.setState({ notRecording: false });
            } else {
                this.refPlayer.current.Stop();
            }
        
        // RecFinish画面が表示から非表示へとフェーズが変化したとき
        }else if (prevState.phase === 2 && this.state.phase === 0) {
            // 全ての再生開始時間をクリア
            const tempRecords = this.state.records.slice();
            for (const record of tempRecords) {
                record.startTime = 0;
            }
            this.setState({ 
                currentRecordStartTime: 0,
                records: tempRecords
            });
        }
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.records !== nextProps.records) {
            return {
                records: nextProps.records,
            };
        }
        return null;
    }

    checkLoadEnded = (loadedAudio) => {
        if (loadedAudio < Object.keys(this.state.records).length) {
            return false;
        }
        return true;
    }

    onSuccessAudio = (audio, id) => {
        let audios = this.state.records;
        let loadedAudio = this.state.loadedAudio + 1;
        audios[id].audioData = audio;
        this.setState({
            records: audios,
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }
    onFailureAudio = (status, error) => {
        let loadedAudio = this.state.loadedAudio + 1;
        this.setState({
            loadedAudio: loadedAudio,
            loading: !this.checkLoadEnded(loadedAudio)
        })
    }

    phaseInit() {
        this.setState({ phase: 0 });
    }
    onClickRecStart = (e) => {
        if (this.props.sendMax === 0) {
            this.setState({ displayUpgrade: true });
        } else {
            this.phaseNext();
            this.startRecording();
        }
    }
    onClickRecStop = (e) => {
        this.phaseNext();
        this.stopRecording();
        this.setState({ notRecording: false });
    }
    startRecording = () => {
        this.Recorder.startRecording();
        this.setState({
            prepare: 0,
            recording: true,
        });
        setTimeout(() => {
            if (this.state.recording) {
                this.onClickRecStop();
                this.setState({
                    recording: false,
                });
            }
        }, 1800000);
    }
    stopRecording = () => {
        this.Recorder.stopRecording();
        this.refPlayer.current.Stop();

        this.setState({
            recording: false,
        });
    }

    onNewRecording = (evt) => {
        this.setState({
            currentRecord: evt.detail.recording.blobUrl,
            prepare: 1,
        });

    }

    onExportFinish = (result) => {
        this.setState({
            currentRecord: result,
            prepare: 1,
        });

    }

    phaseNext() {
        let phase = this.state.phase;
        phase++;
        if (phase >= this.maxPhase) {
            phase = 0;
        }
        this.setState({ phase: phase });
    }

    onClickPlay = (index, play, callback) => {
        if(play) {
            this.audioPlay(index, callback);
        } else {
            this.audioStop();
        }
    }
    audioPlay(index, callback) {
        if(this.state.playingIndex >= 0){ //再生中に別の再生をした場合の対応
            // 再生開始時間を保持
            this.setStartTime(this.refAudio.current.currentTime);
        }
        if (index === 0) {
            if (this.state.currentRecord === "") {
                return;
            }
            this.refAudio.current.src = this.state.currentRecord;
            this.refAudio.current.currentTime = this.state.currentRecordStartTime;
        } else {
            this.refAudio.current.src = this.state.records[index - 1].audioData;
            if(this.state.records[index - 1].startTime){
                this.refAudio.current.currentTime = this.state.records[index - 1].startTime;
            }
        }
        this.refAudio.current.load();
        if (this.refAudio.current.readyState === 4) {
            this.refAudio.current.play();
        } else {
            this.refAudio.current.addEventListener('canplaythrough', this.onCanplaythrough);
        }
        // 再生中のindexを設定
        this.setState({ playingIndex: index });
        if(callback){
            this.audioCallback=callback;
            this.refAudio.current.addEventListener('ended', this.onEnded);
        }
    }
    audioStop() {
        this.refAudio.current.pause();
        // 再生開始時間を保持
        this.setStartTime(this.refAudio.current.currentTime);
        // 再生中indexをクリア
        this.setState({ playingIndex: -1 });
        // イベントリスナー削除
        this.refAudio.current.removeEventListener('ended', this.onEnded);
        // RecFinish画面の再生ステータスをOFF
        this.audioCallback();
    }
    onEnded = (e) => {
        // 再生開始時間をクリア
        this.setStartTime(0);
        // 再生中indexをクリア
        this.setState({ playingIndex: -1 });
        // イベントリスナー削除
        this.refAudio.current.removeEventListener('ended', this.onEnded);
        // RecFinish画面の再生ステータスをOFF
        this.audioCallback();
    }
    setStartTime = (time) => {
        if(this.state.playingIndex == 0){
            this.setState({ currentRecordStartTime: time });
        } else if (this.state.playingIndex > 0){
            const tempRecords = this.state.records.slice();
            tempRecords[this.state.playingIndex-1].startTime = time;
            this.setState({ records: tempRecords });
        }
    }
    onCanplaythrough = (e) => {
        this.refAudio.current.removeEventListener('canplaythrough', this.onCanplaythrough);
        this.refAudio.current.play();
    }

    onSuccessSave = (record) => {
        let records = this.state.records ? this.state.records : [];
        if (Object.keys(records).length >= MAX_RECORD_HISTORY) {
            records.shift();
        }
        record.audioData = this.state.currentRecord;
        records.push(record);
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.props.dispatch({
            type: 'SaveRecord',
            records: records,
        });
        this.setState({
            records: records,
        });
    }
    onFailure = (status, error) => {
    }

    saveRecord() {
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'SaveRecord_Saga',
            userID: this.props.user.id,
            subjectID: this.props.subject.id,
            audio: this.state.currentRecord,
            onSuccess: this.onSuccessSave,
            onFailure: this.onFailure,
        });
    }

    onClickSave = () => {
        let records = this.state.records ? this.state.records : [];
        let count = 0;
        for (let key in records) {
            if (records[key]) {
                count++;
            }
        }
        if (count >= MAX_RECORD_HISTORY) {
            this.setState({ displaySaveCnf: true });
        } else {
            this.saveRecord();
            this.phaseNext();
        }
    }

    onClickSend = (index) => {
        let sendCount = this.state.sendCount;
        let send = false;
        if (this.props.sendMax === 0) {
            this.setState({ displayUpgrade: true });
            return;
        } else if (this.props.sendMax === -1) {
            send = true;
        } else {
            if (sendCount + 1 <= this.props.sendMax) {
                send = true;
            } else {
                this.setState({ displayCountOver: true });
                return;
            }
        }
        this.props.dispatch({
            type: "LoadStart"
        });
        this.props.dispatch({
            type: 'GetShadowingSend_Saga',
            userID: this.props.user.id,
            onSuccess: this.onSuccessGetShadowingSend,
            onFailure: this.onFailure,
        });

        if (send) {
            this.setState({
                sendReady: index,
            });
        }
    }
    onSuccessGetShadowingSend = (isAllowed) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        if (isAllowed===SHADOWING_SEND_TWICE.ALLOW) {
            this.setState({ displaySendCnf: true });
        } else {
            this.setState({
                sendReady: -1,
                displaySentToday: true,
            });
        }
    }

    onClickSent = (index) => {
        this.setState({ displaySentCnf: true });
    }

    onSuccessSaveSend = (record) => {
        let records = this.state.records ? this.state.records : [];
        if (Object.keys(records).length >= MAX_RECORD_HISTORY) {
            records.shift();
        }
        record.audioData = this.state.currentRecord;
        records.push(record);
        this.props.dispatch({
            type: 'SaveRecord',
            records: records,
        });
        this.setState({
            records: records,
        });
        this.props.dispatch({
            type: 'SendRecord_Saga',
            id: record.id,
            onSuccess: this.onSuccessSend,
            onFailure: this.onFailure,
        });
    }
    onSuccessSend = () => {
        this.props.dispatch({
            type: "GetRecordHistory_Saga",
            id: this.props.user.id,
            subjectID: this.props.subject.id,
            onSuccess: this.onSuccessGetHistory,
        });
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.phaseNext();
        this.setState({
            sendReady: -1,
            displaySendCnf: false,
        });
    }
    onSuccessGetHistory = (history) => {
        this.loadingRecordHistory = false;
        this.props.dispatch({
            type: 'SaveRecord',
            records: history,
        });
    }

    onClickSendCnf = () => {
        if(this.isTap.current) return; 
        this.isTap.current = true; 
        this.props.dispatch({
            type: "LoadStart"
        });
        let index = this.state.sendReady;
        if (index > 0) {
            this.props.dispatch({
                type: 'SendRecord_Saga',
                id: this.state.records[index - 1].id,
                onSuccess: this.onSuccessSend,
                onFailure: this.onFailure,
            });
        } else {
            this.props.dispatch({
                type: 'SaveRecord_Saga',
                userID: this.props.user.id,
                subjectID: this.props.subject.id,
                audio: this.state.currentRecord,
                onSuccess: this.onSuccessSaveSend,
                onFailure: this.onFailure,
            });
        }
        setTimeout(() => {
            this.isTap.current = false; 
        }, 2000);

    }

    onClickSendCancel = () => {
        this.setState({ displaySendCnf: false });
    }
    onClickSentCancel = () => {
        this.setState({ displaySentCnf: false });
    }

    createSendDlgProps() {
        let message = (
            <div>
                <div>
                    音声ファイルを送信します。
                </div>
                <div style={{fontSize: '16px'}}>
                    ※音声が鮮明に録音されているか、<br />
                    送信前に必ずご確認ください
                </div>
            </div>
        );
        let contents = (
            <DialogMessage Title="確認" Message={message} Size="18px" />
        )
        return {
            display: this.state.displaySendCnf,
            contents: contents,
            controls: {
                'はい': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickSendCnf,
                },
                'いいえ': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickSendCancel,
                }
            }
        }
    }

    sentDlgProps() {
        let contents = (
            <DialogMessage Title="　" Message="この音声ファイルは送信済みです" Size="18px" />
        )
        return {
            display: this.state.displaySentCnf,
            contents: contents,
            controls: {
                'OK': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickSentCancel,
                }
            }
        }
    }

    onClickDelete = (index) => {
        this.setState({
            displayDeleteCnf: true,
            deleteReady: index,
        });
    }

    onSuccessDelete = (index) => {
        this.props.dispatch({
            type: "LoadEnd"
        });
        this.audioStop(); // 再生停止
        let records = this.state.records ? this.state.records : [];
        records.splice(index, 1);
        this.props.dispatch({
            type: 'SaveRecord',
            records: records,
        });
        this.setState({
            records: records,
            deleteReady: -1,
            displayDeleteCnf: false
        });
    }

    onClickDeleteCnf = () => {
        let index = this.state.deleteReady;
        if (index > 0) {
            this.props.dispatch({
                type: "LoadStart"
            });
            this.props.dispatch({
                type: 'DeleteRecord_Saga',
                id: this.state.records[index - 1].id,
                index: index - 1,
                onSuccess: this.onSuccessDelete,
                onFailure: this.onFailure,
            });
        } else {
            this.phaseNext();
            this.setState({ 
                displayDeleteCnf: false,
                currentRecordStartTime: 0
             });
        }
    }
    onClickNotDelete = () => {
        this.setState({ displayDeleteCnf: false });
    }

    createDeleteDlgProps() {
        let contents = (
            <DialogMessage Title="確認" Message="音声ファイルを削除します" Size="18px" />
        )
        return {
            display: this.state.displayDeleteCnf,
            contents: contents,
            controls: {
                'はい': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickDeleteCnf,
                },
                'いいえ': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickNotDelete,
                }
            }
        }
    }

    onClickSaveCnf = () => {
        this.saveRecord();
        this.setState({ displaySaveCnf: false });
        this.phaseNext();
    }
    onClickNotSave = () => {
        this.setState({ displaySaveCnf: false });
    }

    createSaveCnfDlgProps() {
        let message = (
            <div>
                一番古い履歴を上書きします。<br />
                よろしいですか？<br />
                履歴は手動で削除することができます。
            </div>
        );
        let contents = (
            <DialogMessage Title="確認" Message={message} Size="18px" />
        )
        return {
            display: this.state.displaySaveCnf,
            contents: contents,
            controls: {
                'はい': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickSaveCnf,
                },
                'いいえ': {
                    Color: '#000',
                    Size: '18px',
                    onClick: this.onClickNotSave,
                }
            }
        }
    }

    onClickMicError = () => {
        this.setState({
            displayMicError: false
        });
    }

    onClickDiaplayRecList = (e) => {
        if (this.props.sendMax === 0) {
            this.setState({ displayUpgrade: true });
        } else {
            this.setState({
                phase: 2,
                notRecording: true,
                // クリア処理
            });
        }
    }
    onClickDiaplayRecListBack = (e) => {
        this.setState({
            phase: 0,
        });
    }

    createUpgradeDlgProps() {
        let message = (
            <div>
                こちらのアカウントのプランは<br />
                フィードバックを受けられません。<br />
                アカウントのプランを<br />
                「フィードバックプラン」<br />
                に変更してください。
            </div>
        );
        let contents = (
            <DialogMessage Title="録音機能について" Message={message} />
        )
        return {
            display: this.state.displayUpgrade,
            contents: contents,
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: () => {
                        this.setState({ displayUpgrade: false });
                    },
                },
            }
        }
    }

    createCountOverDlgProps() {
        let contents = (
            <DialogMessage Title="確認" Message="フィードバック依頼の上限に達しています。" />
        )
        return {
            display: this.state.displayCountOver,
            contents: contents,
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: () => {
                        this.setState({ displayCountOver: false });
                    },
                },
            }
        }
    }
    createSentTodayDlgProps() {
        let message = (
            <div>
                シャドーイングの送信は1日1回までです。<br />
                AM3時以降に、翌日分の送信が可能となります。
            </div>
        );
        let contents = (
            <DialogMessage Title="確認" Message={message} Align="left" />
        )
        return {
            display: this.state.displaySentToday,
            contents: contents,
            controls: {
                'OK': {
                    Color: '#000',
                    onClick: () => {
                        this.setState({ displaySentToday: false });
                    },
                },
            }
        }
    }

    onClickSwitch = (e) => {
        if (this.state.voiceChangeDisplay) {
            this.setState({ voiceChangeDisplay: false });
        } else {
            this.setState({ voiceChangeDisplay: true });
        }
    }

    render() {
        // ヘッダ:110 切替ボタン:30 TextWrapのpadding:10 audio:70 録音:40 フッタ:50
        const height = (window.innerHeight - 110 - 30 - 10 - 70 - 40 - 50) + "px";
        const voiceChangeHeight = (window.innerHeight - 110 - 30 - 70 - 40 - 50) + "px";
        const btn_on = (
            <i className="fas fa-toggle-on fa-rotate-180"></i>
        );
        const btn_off = (
            <i className="fas fa-toggle-on"></i>
        );
        const switchBtn = this.state.voiceChangeDisplay ? btn_on : btn_off;
        let audioCtrl;

        audioCtrl = (
            <AudioWrap>
                <Audio
                    ref={this.refPlayer}
                    src={[this.props.subject.audioData]}
                    play={0}
                    playbackRate={this.props.playbackRate}
                    onChangePlaybackRate={this.props.onChangePlaybackRate} 
                    rewindDisplay="true"
                    forwardDisplay="true"
                    repeatDisplay="true"
                />
            </AudioWrap>
        );

        let propsRecFinish = {
            display: this.state.phase === 2,
            prepare: this.state.prepare,
            records: this.state.records,
            notRecording: this.state.notRecording,
            onClickPlay: this.onClickPlay,
            onClickSave: this.onClickSave,
            onClickSend: this.onClickSend,
            onClickSent: this.onClickSent,
            onClickDelete: this.onClickDelete,
            onClickBack: this.onClickDiaplayRecListBack,
        };

        let propsDeleteDlg = this.createDeleteDlgProps();
        let propsSendDlg = this.createSendDlgProps();
        let propsSentDlg = this.sentDlgProps();
        let propsSaveCnfDlg = this.createSaveCnfDlgProps();
        let propsUpgradeDlg = this.createUpgradeDlgProps();
        let propsCountOverDlg = this.createCountOverDlgProps();
        let propsSentTodayDlg = this.createSentTodayDlgProps();
        const propsRecIcon = {
            phase: this.state.phase,
            onClickRecStart: this.onClickRecStart,
            onClickRecStop: this.onClickRecStop,
        }

        let RecListIcon;
        let RecIcon;
        RecListIcon = (
            <RecListIconControl onClick={this.onClickDiaplayRecList}>
                録音リスト
            </RecListIconControl>
        );
        RecIcon = (props) => {
            if (props.phase === 1) {
                return (
                    <RecIconControl bg='#ff0000'　onClick={props.onClickRecStop}>
                        <div>
                            録音中
                        </div>
                        <RecordingIcon>
                            <i className="far fa-square"></i>
                        </RecordingIcon>
                    </RecIconControl>
                );
            } else {
                return (
                    <RecIconControl bg='#0077ff' onClick={props.onClickRecStart}>
                        録音する
                    </RecIconControl>
                );
            }
        };

        let PictureEnImage = (this.props.subject.pictureEnData) ? <img src={this.props.subject.pictureEnData} alt="img" /> : '';
        
        

        return (
            <Body Width={this.props.width} Height={this.props.height}>
                <SwitchWrap Disable={this.state.voiceChangeDisable}>
                    <SwitchWord>
                        音声変化
                    </SwitchWord>
                    <SwitchControl onClick={this.onClickSwitch} Disable={this.state.voiceChangeDisable}>
                        ON
                        <SwitchBtn>{switchBtn}</SwitchBtn>
                        OFF
                    </SwitchControl>
                </SwitchWrap>
                <TextWrap Height={height}>
                    <Text>
                        {getSplitedDivs(this.props.subject.textEn, '\n')}
                    </Text>
                </TextWrap>

                <PictureControls Display={this.state.voiceChangeDisplay} Height={voiceChangeHeight}>
                    <PictureControl>
                        <PictureInfo type="button" onClick={() => this.props.onClickHelp(1)}>
                            <img src={renketsu} alt="img" width="30px" height="30px" />
                            <div>
                                連結
                            </div>
                        </PictureInfo>
                        <PictureInfo type="button" onClick={() => this.props.onClickHelp(2)}>
                            <img src={douka} alt="img" width="30px" height="30px" />
                            <div>
                                同化
                            </div>
                        </PictureInfo>
                        <PictureInfo type="button" onClick={() => this.props.onClickHelp(3)}>
                            <img src={datsuraku} alt="img" width="30px" height="30px" />
                            <div>
                                脱落
                            </div>
                        </PictureInfo>
                        <PictureInfo type="button" onClick={() => this.props.onClickHelp(4)}>
                            <img src={ragyoka} alt="img" width="30px" height="30px" />
                            <div>
                                「ら行」化
                            </div>
                        </PictureInfo>
                        <PictureInfo type="button" onClick={() => this.props.onClickHelp(5)}>
                            <img src={jakkei} alt="img" width="30px" height="30px" />
                            <div>
                                弱形
                            </div>
                        </PictureInfo>
                    </PictureControl>

                    <PictureEn> 
                        {PictureEnImage}
                    </PictureEn>
                </PictureControls>

                {audioCtrl}
                <RecFinish {...propsRecFinish} />
                <audio ref={this.refAudio} />

                <RecControls>
                    <RecControl>
                        {RecListIcon}
                        {RecIcon(propsRecIcon)}
                    </RecControl>
                </RecControls>

                <ModalDialog name="delete-dlg" {...propsDeleteDlg} />
                <ModalDialog name="send-dlg" {...propsSendDlg} />
                <ModalDialog name="sent-dlg" {...propsSentDlg} />
                <ModalDialog name="save-cnf-dlg" {...propsSaveCnfDlg} />
                <ModalDialog name="upgrade-dlg" {...propsUpgradeDlg} />
                <ModalDialog name="countover-dlg" {...propsCountOverDlg} />
                <ModalDialog name="senttoday-dlg" {...propsSentTodayDlg} />

                <Loading Display={this.state.loading || this.state.loadingFullText}>
                    <LoadingText>音声ファイル取得中</LoadingText>
                </Loading>
            </Body>
        );
    }
}

export { Training4 };

const Body = styled.div`
    width: ${props => (props.Width)};
    height: ${props => (props.Height)};
    position: relative;
`;

const SwitchWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-right: 10px;
    font-size: 20px;
    opacity: ${props => (props.Disable ? '1' : '0')};
`;

const SwitchWord = styled.div`
    color: #0077FF;
    font-size: 15px;
    line-height: 30px;    
`;

const SwitchControl = styled.div`
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 15px;
    line-height: 30px;
    margin: auto 10px;
    pointer-events: ${props => (props.Disable ? '' : 'none')};
`;

const SwitchBtn = styled.div`
    flex: 1;
    text-align: center;
    display: block;
    margin: auto 2px;
    font-size: 30px;
    color: #0077FF;
`;

const TextWrap = styled.div`
    width: calc(100% - 20px);
    height: ${props => props.Height};
    text-align: center;
    padding: 10px 10px 0;
    display: flex;
    justify-content: center;
    overflow-y: auto;
`;
const Text = styled.div`
    text-align: left;
    font-size: 20px;
`;
const AudioWrap = styled.div`
    display: flex;
    justify-content: center;
`;

const RecControls = styled.div`
    height: 50px;
    bottom: ${props => (props.Display ? '0%' : '-100%')};
`;

const RecControl = styled.div`
    display: flex;
    justify-content: center;
    text-align: center;
    font-size: 15px;
`;
const RecListIconControl = styled.div`
    display: flex;
    width: 100px;
    height: 30px;
    color: #000000;
    background-color: #ddebf7;
    margin: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
`;
const RecIconControl = styled.div`
    display: flex;
    width: 100px;
    height: 30px;
    color: #fff;
    background-color: ${props => (props.bg ? props.bg : 'transparent')};
    margin: 5px;
    border-radius: 5px;
    justify-content: center;
    align-items: center;
`;

    
const RecordingIcon = styled.div`
    color: #fff;
    margin: 5px;
`;

const Loading = styled.div`
    display: ${props => props.Display ? "" : "none"};
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.8);
    position: absolute;
    top: 0;
    left: 0;
`;

const anime = keyframes`
    0% {border: 1px solid #ddd; color: #ddd;}
   50% {border: 1px solid #0077ff; color: #0077ff;}
  100% {border: 1px solid #ddd; color: #ddd;}
`;

const LoadingText = styled.div`
    border: 1px solid #ddd;
    color: #ddd;
    border-radius: 20px;
    background-color: #fff;
    padding: 5px 20px;
    text-align: center;
    position: absolute;
    top: 50px;
    left: 50%;
    max-width: 60%;
    transform: translateX(-50%);
    animation: ${anime} linear 2s;
    animation-iteration-count: infinite;
`;

const PictureControls = styled.div`
    display: ${props => props.Display ? "" : "none"};
    position: absolute;
    height: ${props => props.Height};
    background-color: #fff;
    top: 30px;
    left: 0;
    width: 100%;
    overflow-y: scroll;
`;

const PictureControl = styled.div`
    display: flex;
    background-color: #f5deb3;
    justify-content: center;
    align-items: center;
    height: 50px;
`;

const PictureInfo = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    margin: 15px;
`;
const PictureEn = styled.div`
    width: 100%;
    background-color: #fff;
    text-align : center
    padding: 10px 0 0;
`;
